<template>
  <div>
    <dl class="pvd-description-list">
      <!-- TODO: if we need more than 1 PDF need to loop  below dt tag.-->
      <dt>
        <a
          href="#"
          @click.prevent="handleClick(pdfUrl)"
        ><pvd-icon
          aria-hidden="true"
          icon="download"
        />{{ pdfLabel }}</a>
      </dt>
      <dd> {{ pdfDescription }} </dd>
    </dl>
    <p class="xsmall color-neutral">
      {{ footer }}
    </p>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';
import utility from '../mixins/utility';

export default {
  name: 'DescriptionList',
  mixins: [
    dataHelper,
    utility,
  ],
  props: {
    pdfUrl: {
      type: String,
      default: '',
    },
    pdfLabel: {
      type: String,
      default: '',
    },
    pdfDescription: {
      type: String,
      default: '',
    },
    footer: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick(pdfUrl) {
      const url = pdfUrl.replace(/\\/g, ''); // #FIXME Remove this once PNCDP-910 has been fixed
      this.openWindow(url, 'mainwindow', '1024', '500');
    },
  },
};
</script>

<style scoped>
</style>
